export default __webpack_public_path__ + "static/media/blur 1.99e465b7.jpg";